/**
 * mc-header-scroll.js  Rev 2
 * Montalava Co. — Dark header, gold logo always shown.
 *
 * Rev 23 header is always #101611 forest-black; the gold logo
 * (settings.logo PNG) is appropriate in all scroll states.
 * Logo swap is intentionally disabled.
 */
(function () {
  'use strict';
  // No logo swap — gold logo stays visible on the dark header at all times.
})();
